<template>
  <div>
    <div class="subjects">
      <v-subject-button v-for='subject in subjects'
        @click="setSubject(subject)"
        :key="subject.id"
        :type="subject.code"
        :active="selectedSubject && selectedSubject.id === subject.id"
        :disabled="disabledSubject(subject)"
      >
        {{subject.name}}
      </v-subject-button>
    </div>
    <div class="shakai-options" v-if="selectedSubjectHasChild">
      <v-subject-button v-for='option in shakaiOptions'
        @click="setShakaiOption(option)"
        :key="option.id"
        :type="option.code"
        :active="isActiveShakaiOption(option)"
        :disabled="disabledSubjectOption(option)"
      >
        {{option.name}}
      </v-subject-button>
    </div>
  </div>
</template>

<script>
import config from '@/config'
import VSubjectButton from '@/components/atoms/SubjectButton'
import teacher from '../../mixins/teacher';

export default {
  mixins: [teacher],

  components: {
    VSubjectButton
  },

  computed: {
    subjects() {
      return this.$store.getters['master/subjectBases']
    },
    shakaiOptions() {
      return this.$store.getters.selectedSubjectOptions
    },
    selectedSubjectHasChild() {
      return this.$store.getters.selectedSubjectHasChild
    },
    selectedGrade() {
      return this.$store.state.top.selectedGrade;
    },
    selectedSubject() {
      return this.$store.state.top.selectedSubject;
    },
    selectedShakaiOptions() {
      return this.$store.state.top.selectedShakaiOptions
    },
    disabledSubject(){
      return function (subject) {
        return !(this.selectedGrade && this.$store.getters.isValidSubject(subject.id))
      }
    },
    disabledSubjectOption(){
      return function (subject) {
        if (!Object.values(config.shakaiOptionSubjects).includes(subject.code)) return false

        return !(this.selectedGrade && this.$store.getters.isValidSubject(subject.id))
      }
    },
    isActiveShakaiOption(){
      return function (option) {
        return this.selectedShakaiOptions.some(selectedOption => { return selectedOption.id === option.id })
      }
    },
  },

  methods: {
    // 教科ボタンが押された時
    async setSubject(subject) {
      // 押下不可のボタンが押された場合何もしない
      if(!this.$store.getters.isValidSubject(subject.id)) return
      // アクティブなボタンが押されたら何もしない
      if(this.selectedSubject.id === subject.id) return

      this.$store.commit('setSelectedSubject', { subject: subject })
      this.$store.commit('setSelectedShakaiOptions', { options: [] })
      this.$store.commit('setSelectedMaxPointValue', { selectedMaxPointValue: 1 })
      this.$store.commit('setSelectedMaxPoint', { selectedMaxPoint: '100' })
      await this.$store.dispatch('initializeAllConditions')

      let searchCode = subject.code
      // 社会が選択された時は地理を初期選択
      if (this.$store.getters.selectedSubjectHasChild) {
        this.$store.commit('setSelectedShakaiOptions', { options: [this.shakaiOptions[0]] })
        searchCode = this.shakaiOptions[0].code
      }

      this.$store.commit(
        'setCurrentSubjectCondition',
        {
          currentSubjectCondition: this.$store.state.top.allConditions
            .find(condition => condition.code === searchCode)
        }
      )
    },

    // 社会の分野ボタンが押された時
    setShakaiOption(option) {
      if (this.disabledSubjectOption(option)) return

      const isSelected = this.selectedShakaiOptions.some(selectedOption => {
        return selectedOption.id === option.id
      })
      if (!isSelected) {
        // 選択されていないものであればadd
        this.$store.commit('addSelectedShakaiOptions', { option: option })
      } else {
        // 選択済みのものであれば、自分以外を除いてset
        this.$store.commit('setSelectedShakaiOptions',
          {
            options: this.selectedShakaiOptions.filter(selectedOption => {
                return selectedOption.id !== option.id
              })
          }
        )
        // タブが表示中だった場合、他に切り替える
        if (this.currentSubjectCondition.code === option.code) {
          this.$store.commit(
            'setCurrentSubjectCondition',
            {
              currentSubjectCondition: this.selectedShakaiOptions.length > 0
              ? this.$store.getters.sendApiParams[0]
              : {}
            }
          )
        }
      }
    },
  },

  watch: {
    selectedGrade(now) {
      if(!now) return
      this.$store.dispatch('resetSelectedSubject')
    },
  }
}
</script>

<style lang="stylus" scoped>
.subjects
  max-width 900px

.shakai-options
  margin-top 20px
  max-width 800px
</style>
